<!--
/**
* @name: List.vue
* @description: 直播管理-主播列表页面
* @author: 杨波
* @create: 2020/12/01 14:16:58
* @update: 2020/12/01 14:16:58
*/
-->
<template>
  <y-view :loading="isLoading">
    <div :class="css.tip">
      <p style="font-size: 16px;"><k-icon class="k-icon-tip" color="#FAB72D" style="margin-right: 5px;"></k-icon>请注意！</p>
      <p style="margin-left: 21px;">根据微信小程序直播规则，要求主播必须先进行微信实名认证，否则将无法通过校验。</p>
      <p style="margin-left: 21px;">添加主播之前请务必确认已通过实名认证！<span :class="css.label" @click="preview">实名认证入口</span></p>
    </div>
    <y-query spaceBetween :hasSearchButton="false">
      <y-query-item slot="right">
        <y-button class="mt-1" @click="onAddStreamer">添加主播</y-button>
      </y-query-item>
    </y-query>
    <k-table :data="streamerList" :height="$root.tableHeightXXX" :rightFixedNumber="1" :columns="initColumns()"></k-table>
    <k-pagination :total="total" v-if="streamerList && streamerList.length > 0" :current-page.sync="para.pageCurrent" :page-size.sync="para.pageSize" @page-change="onChangePageIndex" />
    <k-popup bind="v-if" okText="保存" title="添加主播" :show.sync="isPopupShow" @after-cancel="onCancel" @after-ok="onSave">
      <y-popup-body size="small">
        <y-form titleAlign="left" titleWidth="70px" contentWidth="200px">
          <y-form-item title="主播微信号:" required align="top">
            <k-input :class="css.inputW" placeholder="请输入主播微信号" clearable v-model="userName"></k-input>
          </y-form-item>
        </y-form>
      </y-popup-body>
    </k-popup>
    <k-popup bind="v-if" layout="header,body,close,mask" title="实名认证" :show.sync="isPopupShowCode">
      <y-popup-body size="small">
        <div :class="css.wrapper">
          <img src="../../../assets/images/code.png" alt="" />
        </div>
      </y-popup-body>
    </k-popup>
  </y-view>
</template>
<script>
import { NESTLE_BROADCAST_SERVER_BROADCAST_MEMBER_PAGE, NESTLE_BROADCAST_SERVER_BROADCAST_MEMBER_SAVE, NESTLE_BROADCAST_SERVER_BROADCAST_MEMBER_DELETE } from "@/assets/modules/apiList";
const initPara = () => ({
  pageCurrent: 1,
  pageSize: 15,
});
export default {
  data() {
    return {
      isLoading: false,
      para: initPara(),
      streamerList: [],
      isPopupShow: false,
      userName: "",
      isSaving: false,
      isPopupShowCode: false,
      total: 0,
    };
  },
  methods: {
    //分页查询操作
    onChangePageIndex(p) {
      this.para.pageCurrent = p;
      this.getStreamerList();
    },
    initColumns() {
      return [
        {
          name: "主播微信号",
          field: "userName",
          style: {
            width: 150,
            "white-space": "normal",
            "line-height": "18px",
          },
        },
        {
          name: "操作",
          field: "action",
          style: {
            textAlign: "center",
            width: 10,
          },
          customRender: (row) => {
            const deleteButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onDelete(row);
                }}
              >
                删除
              </a>
            );
            return <div>{deleteButton}</div>;
          },
        },
      ];
    },
    preview() {
      this.isPopupShowCode = true;
    },
    onAddStreamer() {
      this.userName = "";
      this.isPopupShow = true;
    },
    onCancel() {
      this.isPopupShow = false;
    },
    onSave() {
      let { tip } = this.$root;
      if (!this.userName) {
        return tip("请输入主播微信号");
      }
      if (this.isSaving) {
        return;
      }
      this.isSaving = true;
      this.isLoading = false;
      this.$fetch({
        api: NESTLE_BROADCAST_SERVER_BROADCAST_MEMBER_SAVE,
        para: { userName: this.userName },
      })
        .then((res) => {
          tip("添加成功");
          this.isPopupShow = false;
          this.isSaving = false;
          this.isLoading = false;
          this.getStreamerList();
        })
        .catch(() => {
          this.isPopupShow = false;
          this.isSaving = false;
          this.isLoading = false;
        });
    },
    onDelete(row) {
      let { userName } = row;
      this.$dialog({
        title: "确认删除？",
        content: "删除后不可恢复，你还要继续吗？",
        ok: () => {
          this.isLoading = true;
          this.$fetch({
            api: NESTLE_BROADCAST_SERVER_BROADCAST_MEMBER_DELETE,
            para: { userName },
          })
            .then(() => {
              this.isLoading = false;
              this.getStreamerList();
            })
            .catch(() => {
              this.isLoading = false;
            });
        },
      });
    },
    //获取列表数据
    getStreamerList() {
      let { para } = this;
      this.$fetch({
        api: NESTLE_BROADCAST_SERVER_BROADCAST_MEMBER_PAGE,
        para,
      }).then((res) => {
        this.streamerList = res.pageList || [];
        this.total = res.total;
      });
    },
  },
  created() {
    this.getStreamerList();
  },
  beforeRouteUpdate(to, from, next) {
    this.getStreamerList();
    next();
  },
};
</script>
<style lang="postcss" module="css">
.inputW {
  width: 250px !important;
}
.tip {
  background-color: rgba(255, 251, 230, 1);
  height: 102px;
  padding: 16px 24px 16px 62px;
  box-sizing: border-box;
  border: 1px solid;
  border-color: rgba(255, 229, 143, 1);
  & > p {
    line-height: 26px;
    font-size: 14px;
  }
}
.label {
  color: #1890ff;
  cursor: pointer;
}
.wrapper {
  text-align: center;
}
</style>
